import Image from "next/image";
import React from "react";
import config from "../config";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import cookie from "js-cookie";

const UnbxdProductCardlike = (props) => {
  function convertPricePerSqmToSqft(pricePerSqm) {
    const conversionFactor = 10.7639;
    return (pricePerSqm / conversionFactor).toFixed(0);
  }
  let [mrp, setMrp] = useState(0);
  let [sellingPrice, seSellingPrice] = useState(0);
  let [outOfStock, setOutOfStock] = useState("Add to cart");
  const [AvailableStock, setAvailableStock] = useState(0);

  const getBestPrice = async (pin) => {
    let apiresult = await axios.get(
      `https://obl-js.orientbell.com/api/product-availability-dev?sku=${props.product.sku}&pincode=${pin}&factory=${props.product.tileFactoryProduction}`
    );
    if (apiresult.data?.Plants?.length > 0) {
      let temparr = [];
      if (
        apiresult.data?.Plants.includes("Sikandrabad Plant") &&
        props.product.skdStock
      ) {
        temparr.push(Number(props.product.skdStock));
      }
      if (
        apiresult.data?.Plants.includes("Dora Plant") &&
        props.product.doraStock
      ) {
        temparr.push(Number(props.product.doraStock));
      }
      if (
        apiresult.data?.Plants.includes("Hoskote Plant") &&
        props.product.hoskoteStock
      ) {
        temparr.push(Number(props.product.hoskoteStock));
      }
      if (
        apiresult.data?.Plants.includes("West Zone") &&
        props.product.westZoneStock
      ) {
        temparr.push(Number(props.product.westZoneStock));
      }
      setAvailableStock(temparr.reduce((total, obj) => total + obj, 0));
    } else {
      setAvailableStock("Not Deliverable");
    }
    if (apiresult.data?.transportOrder == 0) {
      return;
    } else if (apiresult.data?.devliverytime) {
      if (apiresult.data?.updated_price_ft) {
        seSellingPrice(apiresult.data?.updated_price_ft);
      }
    } else if (1 > apiresult.data.availableQty) {
      setOutOfStock("Out of Stock");
    } else if (apiresult.data.addesses == "" || !apiresult.data.devliverytime) {
      setOutOfStock("Not Deliverable in your Area");
    }
  };

  const handleOnClick = (Urll) => {
   
    var payload = {
      pid: props.product.uniqueId,
      prank: props.prank,
      experience_pagetype: "Product",
      experience_widget: props.widget,
      requestId: props.UnbxdRecomendatoRequestID,
    };
    let UnbxdVistType = cookie.get("unbxd.visit");
    let UnbxdVistID = cookie.get("unbxd.visitId");
    let UnbxdUserID = cookie.get("unbxd.userId");
    let UnbxdApiKey = "ss-unbxd-aapac-prod-orientbell53741713874410";
    axios.get(
      new URL(
        `https://tracker.unbxdapi.com/v2/1p.jpg?data=${encodeURIComponent(
          JSON.stringify({
            pid: props.product.uniqueId,
            pr: "",
            experience_pagetype: "PRODUCT",
            experience_widget: props.widget,
            requestId: props.UnbxdRecomendatoRequestID,
            url: "https://staging.orientbell.com",
            referrer: "",
            visit_type: UnbxdVistType,
            ver: "4.0.28",
            _uf: 1187461382,
            visitId: UnbxdVistID,
          })
        )}&UnbxdKey=${encodeURIComponent(
          UnbxdApiKey
        )}&action=click&uid=${encodeURIComponent(UnbxdUserID)}`
      ).toString()
    );

    // if(typeof Unbxds !== 'undefined' && Unbxd && typeof Unbxd.track === 'function') {
    //   Unbxd.track('click', payload)
    // } else {
    //   console.log('unbxdAnalytics.js is not loaded!')
    // }
    window.location = Urll;
  };
  useEffect(() => {
    if (cookie.get("pincode")) {
      // getBestPrice(cookie.get('pincode'))
    }
    setMrp(
      convertPricePerSqmToSqft(
        props.product.MRP ? props.product.MRP : props.product.price
      )
    );
    setAvailableStock(
      [
        props.product.hoskoteStock,
        props.product.westZoneStock,
        props.product.doraStock,
        props.product.skdStock,
      ]
        .filter((cc) => cc)
        .reduce((total, obj) => total + Number(obj), 0)
    );
  }, [props]);
  return (
    <>
      <div
        className="obl-searchresult-col"
        id={props.product.uniqueId}
        style={{ width: "100%" }}
      >
        <div class="cate-pro-figure">
          <a
            onClick={(e) => {
              e.preventDefault();
              handleOnClick(
                props.product.productUrl.replace(
                  "https://server.orientbell.com/",
                  "/"
                )
              );
            }}
            href={props.product.productUrl.replace(
              "https://server.orientbell.com/",
              "/"
            )}
          >
            <img
              src={
                props.product.imageUrl?.length ? props.product.imageUrl[0] : ""
              }
            />
          </a>
        </div>
        <div class="cate-pro-text">
          <div class="simi-name">
            <a
              onClick={(e) => {
                e.preventDefault();
                handleOnClick(
                  props.product.productUrl.replace(
                    "https://server.orientbell.com/",
                    "/"
                  )
                );
              }}
              href={props.product.productUrl.replace(
                "https://server.orientbell.com/",
                "/"
              )}
            >
              {props.product.title}
            </a>
          </div>
          {/* <div class="produ-price"><div class="mrp">MRP <strong> ₹ {convertPricePerSqmToSqft(props.product.price)} /- Sq.ft</strong></div></div> */}
          {sellingPrice && Number(mrp) > Number(sellingPrice) ? (
            <div className="mrp">
              Offer price <strong>₹.</strong>{" "}
              <span
                style={{ textDecoration: "line-through", marginRight: "5px" }}
              >
                {" "}
                {Math.round(mrp)}{" "}
              </span>{" "}
              <strong> {Math.round(sellingPrice)} /- Sq.ft </strong>
            </div>
          ) : (
            <div className="mrp">
              MRP <strong> ₹ {Math.round(mrp)} /- Sq.ft</strong>
            </div>
          )}
          <div class="produ-size">
            {/* <div className='produ-size-leftbox'>Size {props.product.tileSize?.length ? props.product.tileSize.join(" ,") : ""}</div> */}
            {/* <div className='produ-size-rightbox'>
              <span
        style={{
          display: "inline-block",
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          backgroundColor:
            AvailableStock > 0 && AvailableStock <= 100
              ? "red"
              : AvailableStock > 100 && AvailableStock <= 250
              ? "orange"
              : AvailableStock > 250 && AvailableStock <= 1000
              ? "lightgreen"
              : AvailableStock > 1000
              ? "darkgreen"
              : "grey",
          marginRight: "5px",
        }}
      ></span>
       {AvailableStock > 0 && AvailableStock <= 100
        ? "Out of Stock"
        : AvailableStock > 100 && AvailableStock <= 250
        ? "Low Stock"
        : AvailableStock > 250 && AvailableStock <= 1000
        ? "Limited Stock"
        : AvailableStock > 1000
        ? "In Stock"
        : AvailableStock == "Not Deliverable" ? "Not Deliverable" : "Out of Stock"}{" "}

              </div> */}
          </div>

          <div class="add-button">
            <a
              onClick={(e) => {
                e.preventDefault();
                handleOnClick(
                  props.product.productUrl.replace(
                    "https://server.orientbell.com/",
                    "/"
                  )
                );
              }}
              href={`${props.product.productUrl.replace(
                "https://server.orientbell.com/",
                "/"
              )}`}
              className="add-pro-btn"
              style={{
                backgroundColor:
                  outOfStock == "Not Deliverable in your Area"
                    ? "#a5a5a5"
                    : outOfStock == "Out of Stock"
                    ? "#ffcb08"
                    : "#0b9444",
              }}
            >
              {outOfStock}
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnbxdProductCardlike;
